// extracted by mini-css-extract-plugin
export var typingIndicator = "_rc-0";